import React from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import styled from '@emotion/styled';
import { Close } from '@mui/icons-material';

const InputStyled = styled('input')({
  display: 'none',
});

const VideoUploadField = ({
  label,
  name,
  formik,
  sx = {},
  videoHeight = '180px',
  videoWidth = '320px',
}) => {
  const handleVideoChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      formik.setFieldValue(name, file);
    }
  };

  const removeVideo = () => {
    formik.setFieldValue(name, null);
  };

  return (
    <Box sx={{ ...sx }}>
      <Typography variant="body1" sx={{ color: '#ADADAD' }}>{label}</Typography>
      <Box
        sx={{
          border: '1px dashed #9A9AA9',
          textAlign: 'center',
          my: 1,
          p: 1,
          height: '180px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '10px',
          backgroundColor: '#F5F6FA',
        }}
      >
        <label htmlFor={`video-upload-${name}`}>
          <InputStyled
            id={`video-upload-${name}`}
            type="file"
            accept="video/*"
            onChange={handleVideoChange}
          />
          <Button
            component="span"
            sx={{
              backgroundColor: '#01A0E2',
              borderRadius: 0,
              px: 3,
              color: '#fff',
              fontSize: '16px',
            }}
          >
            Upload Video
          </Button>
        </label>
      </Box>

      {/* Video Preview */}
      {formik.values[name] && (
        <Box sx={{ position: 'relative', mt: 2 }}>
          <video
            controls
            width={videoWidth}
            height={videoHeight}
            src={formik.values[name] instanceof File ? URL.createObjectURL(formik.values[name]) : ''}
          />
          <IconButton
            size="small"
            onClick={removeVideo}
            sx={{
              position: 'absolute',
              top: 0,
              right: 0,
              backgroundColor: 'rgba(255,255,255,0.7)',
              borderRadius: '50%',
            }}
          >
            <Close fontSize="small" />
          </IconButton>
        </Box>
      )}

      {/* Validation Error */}
      {formik.touched[name] && formik.errors[name] && (
        <Typography color="error" variant="body2" mt={1}>
          {formik.errors[name]}
        </Typography>
      )}
    </Box>
  );
};

export default VideoUploadField;